import { Button } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { Alert } from "../../../components/alert/Alert";

export const WhyPriceDialog = ({
  active,
  setActive,
}: {
  active: boolean;
  setActive: (active: boolean) => void;
}) => {
  return (
    <Dialog active={active} onDismiss={() => setActive(false)}>
      <DialogNavigation
        leftIcon="CHEVRON_DOWN"
        onClickLeftIcon={() => setActive(false)}
        title="Why do I need a price against every product?"
      />
      <DialogContent className="flex flex-col gap-8">
        <p>
          Your base price list is the <b>starting point</b> from which you can
          build your pricing structures.
        </p>
        <p>
          It's important for your base price list to be filled in completely, so
          that any price list you derive from it has a base price to reference.
        </p>
        <Alert
          type="default"
          title="What about product visibility?"
          message="Even if a product has a price set against it, it won't be visible to customers on your storefront unless it’s switched ‘on’ in the appropriate product catalogue"
        >
          <Button color="secondary">Find out more</Button>
        </Alert>
      </DialogContent>
      <DialogCTA>
        <Button onClick={() => setActive(false)}>I understand</Button>
      </DialogCTA>
    </Dialog>
  );
};
